/**
 * Created by Christof Sander on 27.09.2016.
 */

// const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'search'
			],
			core: {
				data:       undefined,
				// multiple:   true
			},
			// checkbox: {
			// 	three_state: false,
			// 	// cascade: 'down+undetermined'
			// 	cascade: 'down'
			// }
		}
	}
};
